// Only the same-origin API prefix is public. OAuth configuration lives on the BFF.
export interface RuntimeConfig {
  api_base_url: string;
}

let cached: RuntimeConfig | null = null;

export async function loadRuntimeConfig(): Promise<RuntimeConfig> {
  if (cached) return cached;
  const res = await fetch("/config.json", { cache: "no-store" });
  if (!res.ok) {
    throw new Error(`/config.json HTTP ${res.status}`);
  }
  const cfg = (await res.json()) as RuntimeConfig;
  if (!cfg.api_base_url || !cfg.api_base_url.startsWith("/") || cfg.api_base_url.startsWith("//")) {
    throw new Error("config.json missing required fields");
  }
  cached = cfg;
  return cfg;
}

/** Синхронный доступ для кода, который выполняется после loadRuntimeConfig.
 *  Бросает если конфиг ещё не загружен — это всегда баг.
 */
export function getConfig(): RuntimeConfig {
  if (!cached) {
    throw new Error("Runtime config not loaded yet — call loadRuntimeConfig first");
  }
  return cached;
}
